import React, { useState } from "react";
import { Dropdown, Menu } from "antd";
import { ActionHandlerFunctions } from "../TripDetails/TripDetailsDrawer";
import { ITripDetails } from "../../ServiceUsers/Interfaces/ITripDetails";
import styles from "./ServicesTable.module.scss";
import addFavoriteIcon from "../../../assets/icons/magentaHeart.svg";
import removeFavoriteIcon from "../../../assets/icons/magentaHeartOutlined.svg";
import editFavoriteIcon from "../../../assets/icons/editFilled.svg";
import rebookIcon from "../../../assets/icons/retweetOutlined.svg";
import cancelIcon from "../../../assets/icons/deleteFilled.svg";
import { Tabs } from "../../../types/TripPaginationFilterTypes";
import { useDashboardCtx } from "../../../context/DashboardContext";

type Props = {
  selectedLeg: ITripDetails;
  actionHandlers: ActionHandlerFunctions;
  isTripDetailsView?: boolean;
  children: React.ReactNode;
};

function DropdownActions({
  selectedLeg,
  actionHandlers,
  isTripDetailsView,
  children,
}: Props) {
  const {
    handleAddFavorite,
    handleRebook,
    handleCancelService,
    handleRemoveFavorite,
    handleRenameFavorite,
  } = actionHandlers;
  const { activeTabCtx } = useDashboardCtx();
  const [activeTab] = activeTabCtx;

  return (
    <Dropdown
      overlay={
        activeTab === Tabs.FAVORITE ? (
          <Menu className={styles.actionsDropdown}>
            <Menu.Item
              key="0"
              className={styles.actionItem}
              onClick={() => handleRemoveFavorite(selectedLeg)}
            >
              <img src={removeFavoriteIcon} alt="add_to_favorite" />
              Remove favorite
            </Menu.Item>

            {!isTripDetailsView && (
              <Menu.Item
                key="1"
                className={styles.actionItem}
                onClick={() =>
                  handleRebook({
                    selectedLeg: selectedLeg,
                    areTripLegsMissing: true,
                  })
                }
              >
                <img src={rebookIcon} alt="rebook_trip" />
                Rebook service
              </Menu.Item>
            )}

            <Menu.Item
              key="2"
              onClick={() => handleRenameFavorite(selectedLeg)}
              className={styles.actionItem}
            >
              <img src={editFavoriteIcon} alt="cancel_trip" />
              Rename service
            </Menu.Item>
          </Menu>
        ) : (
          <Menu className={styles.actionsDropdown}>
            {activeTab === Tabs.PAST && (
              <Menu.Item
                key="0"
                className={styles.actionItem}
                onClick={() => handleAddFavorite(selectedLeg)}
              >
                <img src={addFavoriteIcon} alt="add_to_favorite" />
                Add to favorites
              </Menu.Item>
            )}

            <Menu.Item
              key="1"
              className={styles.actionItem}
              onClick={() => handleRebook({ selectedLeg })}
            >
              <img src={rebookIcon} alt="rebook_trip" />
              Rebook service
            </Menu.Item>

            {activeTab === Tabs.UPCOMING && (
              <Menu.Item
                key="2"
                onClick={() => handleCancelService(selectedLeg)}
                className={styles.actionItem}
              >
                <img src={cancelIcon} alt="cancel_trip" />
                Cancel service
              </Menu.Item>
            )}
          </Menu>
        )
      }
      trigger={["click"]}
      placement="bottomRight"
    >
      {children}
    </Dropdown>
  );
}

export default DropdownActions;
